import { gql } from '@apollo/client';
import userLicenseFragment from '../userLicenseFragment';

const GET_DEACTIVATED_USERS = gql`
  query GetDeactivatedUsers($organizationId: Int, $orgUnitId: Int) {
    deactivatedUsers(organizationId: $organizationId, orgUnitId: $orgUnitId) {
      ...UserLicenseFields
    }
  }
  ${userLicenseFragment}
`;

export default GET_DEACTIVATED_USERS;
